module.exports = __webpack_public_path__ + "img/internet.0c700d41.png";